module.exports = __webpack_public_path__ + "img/verify-back.d11239cc.svg";